// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2RsvX","blurBox":"styles_blurBox__1XuCO","container":"styles_container__vXSPd"};